import {classNames} from "../utils";

const Spinner = props => {
    return (
        <div className={classNames(
            "spinner-wrapper" + (props.button ? ' spinner-wrapper--button' : '') + (props.fullHeight ? ' spinner-wrapper--full-height' : ''),
            props.className || ''
        )}>
            <div className="spinner"/>
        </div>
    );
}

export default Spinner;
